/**
 * Xyqar role taxonomy. Mirrored in Auth0 Action that injects custom claims:
 *   https://xyqar.com/roles  -> string[]
 *   https://xyqar.com/tenant -> { id, slug, plan }
 *   https://xyqar.com/mfa    -> { totp_verified: boolean, methods: string[] }
 */
export type XyqarRole =
  | "super_admin"      // platform owner
  | "admin"            // platform staff
  | "commercial"       // sales
  | "finance"          // billing/AR
  | "exec"             // executive / board room
  | "client_admin"     // tenant owner
  | "client_manager"   // tenant manager
  | "client_viewer"    // tenant read-only
  | "client"           // legacy generic client role
  | "expert"           // talent/consultant
  | "partner"          // subcontractor pool company
  | "advisor"          // prequalification advisor track
  | "ambassador"       // prequalification ambassador track
  | "gtm"              // internal GTM prequalification track
  | "cto"              // executive hiring track
  | "vp-ai"            // executive hiring track
  | "vp-sales"         // executive hiring track
  | "vp-operations"    // executive hiring track
  | "vp-finance"       // executive hiring track
  | "auditor";         // compliance read-only via magic link

export interface XyqarTenant {
  id:    string;
  slug:  string;
  plan:  "standard" | "urgence" | "marketplace" | "enterprise";
}

export interface XyqarMfa {
  totp_verified: boolean;
  methods: string[];
}

export interface XyqarPrincipal {
  sub:    string;
  email:  string;
  name?:  string;
  roles:  XyqarRole[];
  tenant?: XyqarTenant | null;
  mfa:    XyqarMfa;
}

export const CLAIM = {
  ROLES:  "https://xyqar.com/roles",
  TENANT: "https://xyqar.com/tenant",
  MFA:    "https://xyqar.com/mfa",
} as const;
